module.exports = __webpack_public_path__ + "static/media/fans.b3445ae8.jpg";